<template>
    <form @submit="submit" class="item-editor-form">
        <fg-input v-model="item.description" :label="$t('virtual_stops.descriptions')"></fg-input>
        <fg-input v-model="item.latitude" type="number" :label="$t('virtual_stops.latitude')"></fg-input>
        <fg-input v-model="item.longitude" type="number" :label="$t('virtual_stops.longitude')"></fg-input>

        <FormButtons
            @submit="submit" 
            :reset="false" 
            :remove="action == 'edit'" 
            @remove="remove"
            :itemid="this.item.gpscheckpointid"
            :disableSubmit="disabled || loading"
            :disableRemove="disabled || loading "/>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    </form>
</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'
import virtualStops from '@/store/system/virtualStops'
import 'vue-select/dist/vue-select.css';

export default {
    components: {
        FormButtons
    },
    props: {
        item: {        
            default: function () {
                return {
                        "gpsCheckpointId": null,
                        "description": null,
                        "latitude": 0,
                        "longitude": 0
                }
            }        
        },
        action: { default: "new" }
    },
    data: function() {
        return  {
            ok: false,
            error: false,
            loading: false,
            disabled: false,
            infoType: "save"
        }
    },
    watch: {
        item(){
            this.ok = this.error = this.loading = this.disabled = false;            
        } 
    },
    methods: {
        submit(event) {
            if( event ) 
                event.preventDefault();

            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;

            setTimeout(() => { 
                this.$store.dispatch('virtualstops/saveVirtualStops' , this.item).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        },
        reset(event){
            event.preventDefault();
            this.item = {
                "gpsCheckpointId": null,
                "description": null,
                "latitude": 0,
                "longitude": 0
            };              
        },
        remove() {
            this.infoType = "delete";
            this.loading = true;
            setTimeout(() => { 
                this.$store.dispatch('virtualstops/deleteVirtualStops' , this.item.gpsCheckpointId).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                }) 
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    this.disabled = true;
                })
            }, 1000);
        }
    },
    created() {
        if (!this.$store.state.virtualstops) {
            this.$store.registerModule("virtualstops" , virtualStops);
        }

        this.ok = this.error = this.loading = false;            
    }
}
</script>

<style lang="scss">
    div.form-group input.form-control[type=number]  {
        margin: 0; 
        appearance: textfield;
    }
</style>